if (!customElements.get('thinkcar-video-modal')) {
  customElements.define('thinkcar-video-modal', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;

      this.dialog = this.querySelector('dialog');
      this.player = this.querySelector('[data-thinkcar-video-modal-player]');
      if (!this.dialog || !this.player) return;

      this.initialized = true;
      document.addEventListener('click', this.onDocumentClick);
      this.dialog.addEventListener('click', this.onDialogClick);
      this.dialog.addEventListener('close', this.onClose);
    }

    disconnectedCallback() {
      document.removeEventListener('click', this.onDocumentClick);
      this.dialog?.removeEventListener('click', this.onDialogClick);
      this.dialog?.removeEventListener('close', this.onClose);
      this.reset();
      this.initialized = false;
    }

    onDocumentClick = (event) => {
      const trigger = event.target.closest(`[data-thinkcar-video-modal-target="${this.id}"]`);
      if (!trigger) return;

      event.preventDefault();
      this.open(trigger);
    };

    onDialogClick = (event) => {
      if (event.target === this.dialog || event.target.closest('[data-thinkcar-video-modal-close]')) {
        this.dialog.close();
      }
    };

    onClose = () => {
      this.reset();
      document.documentElement.classList.remove('thinkcar-video-modal-open');
      this.activeTrigger?.focus({ preventScroll: true });
      this.activeTrigger = null;
    };

    open(trigger) {
      const host = trigger.dataset.videoHost;
      const videoId = trigger.dataset.videoId;
      if (!host || !videoId) return;

      const iframe = document.createElement('iframe');
      iframe.title = trigger.dataset.videoTitle || 'Video';
      iframe.allow = 'autoplay; encrypted-media; picture-in-picture';
      iframe.allowFullscreen = true;

      if (host === 'youtube') {
        iframe.src = `https://www.youtube.com/embed/${encodeURIComponent(videoId)}?autoplay=1&playsinline=1&rel=0&modestbranding=1&enablejsapi=1`;
      } else if (host === 'vimeo') {
        iframe.src = `https://player.vimeo.com/video/${encodeURIComponent(videoId)}?autoplay=1&autopause=1&transparent=0&responsive=1&portrait=0&title=0&byline=0`;
      } else {
        return;
      }

      this.activeTrigger = trigger;
      this.dialog.dataset.ratio = trigger.dataset.videoRatio || '16-9';
      this.player.replaceChildren(iframe);
      document.documentElement.classList.add('thinkcar-video-modal-open');
      this.dialog.showModal();
    }

    reset() {
      this.player?.replaceChildren();
    }
  });
}
